export default __webpack_public_path__ + "static/media/fillmore.7de1619c.png";